module.exports = __webpack_public_path__ + "img/playersGroup_b.bda8e9ef.svg";